import React, { useState } from 'react';
import './Booking.css';
import Header from '../Components/Layout/Header';
import Footer from '../Components/Layout/Footer';
import Profile from '../Aseets/Img/profile icon.svg';
import Calender from '../Aseets/Img/calender icon.svg';
import Email from '../Aseets/Img/email icon.svg';
import Phone from '../Aseets/Img/phone icon.svg';
import Bookinginput from '../Components/Comman/Booking-input';
import BookingSelect from '../Components/Comman/Booking-select';
import Ticket_Card from '../Components/Comman/Booking_ticket';

const Booking = () => {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', date: '', tickets: '', category: ''
  });
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim())     newErrors.name     = 'Full name is required.';
    if (!form.email.trim())    newErrors.email    = 'Email address is required.';
    if (!form.phone.trim())    newErrors.phone    = 'Phone number is required.';
    if (!form.date)            newErrors.date     = 'Visit date is required.';
    if (!form.tickets)         newErrors.tickets  = 'Number of tickets is required.';
    if (!form.category)        newErrors.category = 'Ticket category is required.';
    return newErrors;
  };

  const handleSubmit = () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setForm({ name: '', email: '', phone: '', date: '', tickets: '', category: '' });
    setErrors({});
  };

  return (
    <>
      <Header />
      <main>
        <section className='section1-booking'>
          <h1 className='booking-text1'>RESERVE YOUR VISIT</h1>
          <p className='booking-text2'>Secure your place at the most exclusive jewelry exhibition of the year. Choose your preferred ticket type and experience luxury redefined.</p>
        </section>
        <section className='section2-booking'>
          <div className='booking-form'>
            <div className='booking-form-div1'>
              <h2 className='booking-form-text1'>Booking Form</h2>
              <div className='booking-form-div2'>
                <Bookinginput title="Full Name*" type="text" placeholder="Enter your full name"
                  icon={<img src={Profile} alt="Profile Icon" />}
                  value={form.name} onChange={e => handleChange('name', e.target.value)}
                  error={errors.name} />
                <Bookinginput title="Email Address*" type="email" placeholder="Enter your email address"
                  icon={<img src={Email} alt="Email Icon" />}
                  value={form.email} onChange={e => handleChange('email', e.target.value)}
                  error={errors.email} />
                <Bookinginput title="Phone Number*" type="tel" placeholder="Enter your phone number"
                  icon={<img src={Phone} alt="Phone Icon" />}
                  value={form.phone} onChange={e => handleChange('phone', e.target.value)}
                  error={errors.phone} />
                <Bookinginput title="Visit Date*" type="date" placeholder="Select your preferred date"
                  icon={<img src={Calender} alt="Calender Icon" />}
                  value={form.date} onChange={e => handleChange('date', e.target.value)}
                  error={errors.date} />
                <BookingSelect title="TICKET CATEGORY*"
                  value={form.category} onChange={e => handleChange('category', e.target.value)}
                  error={errors.category}
                  icon={
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M2 9C2 7.89543 2.89543 7 4 7H20C21.1046 7 22 7.89543 22 9V9.5C21.1716 9.5 20.5 10.1716 20.5 11C20.5 11.8284 21.1716 12.5 22 12.5V13C22 14.1046 21.1046 15 20 15H4C2.89543 15 2 14.1046 2 13V12.5C2.82843 12.5 3.5 11.8284 3.5 11C3.5 10.1716 2.82843 9.5 2 9.5V9Z" stroke="rgba(214, 184, 147, 0.70)" strokeWidth="1.5"/>
                    </svg>
                  } />
                <Bookinginput title="NUMBER OF TICKETS*" type="number" placeholder="Enter number of tickets"
                  value={form.tickets} onChange={e => handleChange('tickets', e.target.value)}
                  error={errors.tickets} />
                <button className='booking_button' onClick={handleSubmit}>CONFIRM BOOKING</button>
              </div>
              <h6 className='booking_buttom_text'>* Required fields. Your information is secure and will not be shared.</h6>
            </div>
          </div>
          <div className='booking-cards-div'>
            <Ticket_Card title="Standard Access" price="250 EGP" text1="Event catalog" text2="General seating" text3="Exhibition access" />
            <Ticket_Card title="VIP Access" price="500 EGP" text1="Standard Access" text2="VIP lounge" text3="Guided tours" text4="Priority access" />
            <Ticket_Card title="Collector's Pass" price="1000 EGP" text1="All VIP benefits" text2="Private viewings" text3="Meet designers" text4="Auction access" />
          </div>
        </section>
      </main>


      {showModal && (
        <div className='modal-overlay'>
          <div className='modal-box'>
            <div className='modal-icon'>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="11" stroke="#D6B893" strokeWidth="1.5" />
                <path d="M7 12.5L10.5 16L17 9" stroke="#D6B893" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 className='modal-title'>BOOKING CONFIRMED</h2>
            <div className='modal-divider' />
            <div className='modal-details'>
              <p><span>Name</span><span>{form.name}</span></p>
              <p><span>Email</span><span>{form.email}</span></p>
              <p><span>Phone</span><span>{form.phone}</span></p>
              <p><span>Date</span><span>{form.date}</span></p>
              <p><span>Category</span><span>{form.category}</span></p>
              <p><span>Tickets</span><span>{form.tickets}</span></p>
            </div>
            <div className='modal-divider' />
            <p className='modal-sub'>A confirmation will be sent to your email shortly.</p>
            <button className='modal-close' onClick={handleClose}>CLOSE</button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Booking;